import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38c0eeca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "partner" }
const _hoisted_2 = { class: "partner-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "header-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Clientes")
], -1))
const _hoisted_4 = { class: "header-info" }
const _hoisted_5 = { class: "info-label" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Link de criação de conta   ")
const _hoisted_7 = { style: {"cursor":"pointer"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Para criar uma nova conta no ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Certificata, oriente seu cliente para ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" acessar o link fornecido abaixo. ")
const _hoisted_13 = { class: "copy-link" }
const _hoisted_14 = { class: "header-client" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Cadastrar Cliente")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Chaves API")
const _hoisted_17 = { class: "partner-search" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Cadastrar cliente", -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Pessoa Jurídica ")
const _hoisted_20 = { class: "cp" }
const _hoisted_21 = { class: "cp" }
const _hoisted_22 = { class: "cp" }
const _hoisted_23 = { class: "cp" }
const _hoisted_24 = { class: "cp" }
const _hoisted_25 = { class: "cp" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Pessoa Física ")
const _hoisted_27 = { class: "cp" }
const _hoisted_28 = { class: "cp" }
const _hoisted_29 = { class: "cp" }
const _hoisted_30 = { class: "cp" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Cadastrar")
const _hoisted_33 = { class: "show-keys-partner" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "show-keys-header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Chaves API"),
  /*#__PURE__*/_createElementVNode("p", null, "Utilize os dados abaixo para consumir os recursos da API")
], -1))
const _hoisted_35 = { class: "copy-key" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-key" }, "Account ID", -1))
const _hoisted_37 = { class: "copy-key" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-key" }, "Api Key", -1))
const _hoisted_39 = { class: "copy-key" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-key" }, "Secret Key", -1))
const _hoisted_41 = { class: "copy-keys-obs" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("   Para sua segurança, evite compartilhar esses dados com outras pessoas! ")
const _hoisted_43 = { class: "lnk-docs-api" }
const _hoisted_44 = {
  href: "https://doc-api.certificata.com.br",
  target: "_blank"
}
const _hoisted_45 = /*#__PURE__*/_createTextVNode("   Consultar Documentação da API")
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"color":"#174C7E","margin-bottom":"0"} }, "Tornar cliente em parceiro", -1))
const _hoisted_47 = {
  key: 0,
  style: {"font-size":"13px","color":"#6B7280","font-weight":"normal","margin-top":"4px"}
}
const _hoisted_48 = { class: "turn-partner-form" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label" }, [
  /*#__PURE__*/_createTextVNode("Descrição da parceria "),
  /*#__PURE__*/_createElementVNode("span", { class: "tp-required" }, "*")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label" }, [
  /*#__PURE__*/_createTextVNode("CPF/CNPJ da conta "),
  /*#__PURE__*/_createElementVNode("span", { class: "tp-required" }, "*")
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label tp-label-bold" }, [
  /*#__PURE__*/_createTextVNode("Parametrização "),
  /*#__PURE__*/_createElementVNode("span", { class: "tp-optional" }, "(opcional)")
], -1))
const _hoisted_52 = { class: "tp-row-2" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label-small" }, "Comissão (%)", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label-small" }, "Desconto (%)", -1))
const _hoisted_55 = { class: "tp-plans-header" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label-bold" }, [
  /*#__PURE__*/_createTextVNode("Planos "),
  /*#__PURE__*/_createElementVNode("span", { class: "tp-required" }, "*")
], -1))
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Adicionar plano ")
const _hoisted_58 = { class: "tp-plan-card-header" }
const _hoisted_59 = { class: "tp-row-2" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label-small" }, "Nome do plano", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label-small" }, "Valor (R$)", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label-small" }, "Nº usuários", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label-small" }, "Nº envelopes", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label-small" }, "Nº WhatsApp", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label-small" }, [
  /*#__PURE__*/_createTextVNode("Período teste (dias) "),
  /*#__PURE__*/_createElementVNode("span", { class: "tp-optional" }, "(opcional)")
], -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label tp-label-bold" }, [
  /*#__PURE__*/_createTextVNode("Funcionalidades do parceiro "),
  /*#__PURE__*/_createElementVNode("span", { class: "tp-required" }, "*")
], -1))
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" API ")
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" App ")
const _hoisted_69 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" Tornar parceiro ")
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"color":"#174C7E","margin-bottom":"0"} }, "Dados da parceria", -1))
const _hoisted_72 = {
  key: 0,
  style: {"font-size":"13px","color":"#6B7280","font-weight":"normal","margin-top":"4px"}
}
const _hoisted_73 = {
  key: 0,
  class: "turn-partner-form"
}
const _hoisted_74 = { class: "tp-row-2" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label-small" }, "Comissão", -1))
const _hoisted_76 = { class: "tp-readonly-value" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label-small" }, "Desconto", -1))
const _hoisted_78 = { class: "tp-readonly-value" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label-bold" }, "Planos cadastrados", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tp-label tp-label-bold" }, "Funcionalidades ativas", -1))
const _hoisted_81 = { class: "tp-features" }
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" API ")
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" App ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoCircleTwoTone = _resolveComponent("InfoCircleTwoTone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_CopyOutlined = _resolveComponent("CopyOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_ApiOutlined = _resolveComponent("ApiOutlined")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_CustomersDataTable = _resolveComponent("CustomersDataTable")!
  const _component_ShopOutlined = _resolveComponent("ShopOutlined")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_InfoCircleOutlined = _resolveComponent("InfoCircleOutlined")!
  const _component_ReadOutlined = _resolveComponent("ReadOutlined")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_MobileOutlined = _resolveComponent("MobileOutlined")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("sup", _hoisted_7, [
              _createVNode(_component_a_tooltip, null, {
                title: _withCtx(() => [
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_InfoCircleTwoTone)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("section", _hoisted_13, [
            _createVNode(_component_a_input_group, { compact: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.linkPartnerClient,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.linkPartnerClient) = $event)),
                  disabled: true,
                  class: "cp-lnk"
                }, null, 8, ["value"]),
                _createVNode(_component_a_tooltip, { title: "Copiar link" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { onClick: _ctx.copyLinkPartner }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CopyOutlined)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("section", _hoisted_14, [
          _createElementVNode("button", {
            class: "btn-add",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showModalCreate && _ctx.showModalCreate(...args)))
          }, [
            _createVNode(_component_UserOutlined),
            _hoisted_15
          ]),
          (_ctx.isFeatureApi)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn-key",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModalKeysPartner(_ctx.partnerHash)))
              }, [
                _createVNode(_component_ApiOutlined),
                _hoisted_16
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("section", _hoisted_17, [
        _createVNode(_component_a_input_search, {
          value: _ctx.dataSearch,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataSearch) = $event)),
          placeholder: "Pesquise pelo cliente",
          "enter-button": "",
          onSearch: _ctx.onSearch,
          class: "cp-search",
          "allow-clear": ""
        }, null, 8, ["value", "onSearch"])
      ]),
      _createVNode(_component_CustomersDataTable, {
        ref: "customersTable",
        partnerHash: _ctx.partnerHash,
        isFeatureApi: _ctx.isFeatureApi,
        search: _ctx.searchExecuted,
        onTurnPartner: _ctx.showModalTurnPartner,
        onViewPartner: _ctx.showModalViewPartner
      }, null, 8, ["partnerHash", "isFeatureApi", "search", "onTurnPartner", "onViewPartner"])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.open,
      onOk: _ctx.handleOk,
      closable: false
    }, {
      header: _withCtx(() => [
        _hoisted_18
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "back",
          onClick: _ctx.handleCancel
        }, {
          default: _withCtx(() => [
            _hoisted_31
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          onClick: _ctx.handleOk,
          disabled: _ctx.canCreate
        }, {
          default: _withCtx(() => [
            _hoisted_32
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_tabs, {
          activeKey: _ctx.activeKey,
          "onUpdate:activeKey": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.activeKey) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, { key: "1" }, {
              tab: _withCtx(() => [
                _createElementVNode("span", null, [
                  _createVNode(_component_ShopOutlined),
                  _hoisted_19
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_20, [
                  _createVNode(_component_a_input, {
                    value: _ctx.formPartnerClient.company,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formPartnerClient.company) = $event)),
                    placeholder: "Nome fantasia",
                    size: "large"
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("span", _hoisted_21, [
                  _withDirectives(_createVNode(_component_a_input, {
                    value: _ctx.formPartnerClient.cnpj,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formPartnerClient.cnpj) = $event)),
                    placeholder: "CNPJ",
                    size: "large"
                  }, null, 8, ["value"]), [
                    [_directive_maska, '##.###.###/####-##']
                  ])
                ]),
                _createElementVNode("span", _hoisted_22, [
                  _createVNode(_component_a_input, {
                    value: _ctx.formPartnerClient.name,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formPartnerClient.name) = $event)),
                    placeholder: "Nome completo",
                    size: "large"
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("span", _hoisted_23, [
                  _withDirectives(_createVNode(_component_a_input, {
                    value: _ctx.formPartnerClient.cpf,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formPartnerClient.cpf) = $event)),
                    placeholder: "CPF",
                    size: "large"
                  }, null, 8, ["value"]), [
                    [_directive_maska, '###.###.###-##']
                  ])
                ]),
                _createElementVNode("span", _hoisted_24, [
                  _createVNode(_component_a_input, {
                    value: _ctx.formPartnerClient.email,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formPartnerClient.email) = $event)),
                    placeholder: "E-mail",
                    size: "large"
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("span", _hoisted_25, [
                  _withDirectives(_createVNode(_component_a_input, {
                    value: _ctx.formPartnerClient.phone,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formPartnerClient.phone) = $event)),
                    "addon-before": "+55",
                    "addon-after": "Whatsapp",
                    placeholder: "(00) 0 0000-0000",
                    size: "large"
                  }, null, 8, ["value"]), [
                    [_directive_maska, ['(##) # ####-####', '(##) ####-####']]
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, { key: "2" }, {
              tab: _withCtx(() => [
                _createElementVNode("span", null, [
                  _createVNode(_component_UserOutlined),
                  _hoisted_26
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_27, [
                  _createVNode(_component_a_input, {
                    value: _ctx.formPartnerClient.name,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formPartnerClient.name) = $event)),
                    placeholder: "Nome completo",
                    size: "large"
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("span", _hoisted_28, [
                  _withDirectives(_createVNode(_component_a_input, {
                    value: _ctx.formPartnerClient.cpf,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formPartnerClient.cpf) = $event)),
                    placeholder: "CPF",
                    size: "large"
                  }, null, 8, ["value"]), [
                    [_directive_maska, '###.###.###-##']
                  ])
                ]),
                _createElementVNode("span", _hoisted_29, [
                  _createVNode(_component_a_input, {
                    value: _ctx.formPartnerClient.email,
                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formPartnerClient.email) = $event)),
                    placeholder: "E-mail",
                    size: "large"
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("span", _hoisted_30, [
                  _withDirectives(_createVNode(_component_a_input, {
                    value: _ctx.formPartnerClient.phone,
                    "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formPartnerClient.phone) = $event)),
                    "addon-before": "+55",
                    "addon-after": "Whatsapp",
                    placeholder: "(00) 0 0000-0000",
                    size: "large"
                  }, null, 8, ["value"]), [
                    [_directive_maska, ['(##) # ####-####', '(##) ####-####']]
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeKey"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.isShowKeysApi,
      "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.isShowKeysApi) = $event)),
      centered: "",
      footer: null,
      maskClosable: false,
      width: "1000px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("section", _hoisted_35, [
            _hoisted_36,
            _createVNode(_component_a_input_group, { compact: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.accountIdApi,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.accountIdApi) = $event)),
                  size: "large",
                  disabled: true,
                  class: "cp-key"
                }, null, 8, ["value"]),
                _createVNode(_component_a_tooltip, { title: "Copiar Hash da conta" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      size: "large",
                      onClick: _ctx.copyAccoundId
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CopyOutlined)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("section", _hoisted_37, [
            _hoisted_38,
            _createVNode(_component_a_input_group, { compact: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.apiKey,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.apiKey) = $event)),
                  size: "large",
                  disabled: true,
                  class: "cp-key"
                }, null, 8, ["value"]),
                _createVNode(_component_a_tooltip, { title: "Copiar Chave Api" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      size: "large",
                      onClick: _ctx.copyApiKey
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CopyOutlined)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("section", _hoisted_39, [
            _hoisted_40,
            _createVNode(_component_a_input_group, { compact: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.secretKey,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.secretKey) = $event)),
                  size: "large",
                  disabled: true,
                  class: "cp-key"
                }, null, 8, ["value"]),
                _createVNode(_component_a_tooltip, { title: "Copiar Chave Secreta" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      size: "large",
                      onClick: _ctx.copySecretKey
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CopyOutlined)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("span", _hoisted_41, [
            _createVNode(_component_InfoCircleOutlined),
            _hoisted_42
          ]),
          _createElementVNode("span", _hoisted_43, [
            _createElementVNode("a", _hoisted_44, [
              _createVNode(_component_ReadOutlined),
              _hoisted_45
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.isShowTurnPartner,
      "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.isShowTurnPartner) = $event)),
      centered: "",
      maskClosable: false,
      width: "640px",
      onCancel: _ctx.handleCancelTurnPartner,
      wrapClassName: "partner-modal"
    }, {
      title: _withCtx(() => [
        _hoisted_46,
        (_ctx.selectedCustomer)
          ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(_ctx.selectedCustomer.name), 1))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "back",
          class: "tp-btn-cancel",
          onClick: _ctx.handleCancelTurnPartner
        }, {
          default: _withCtx(() => [
            _hoisted_69
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          key: "submit",
          class: "tp-btn-submit",
          disabled: _ctx.canTurnPartner,
          loading: _ctx.isSubmittingTurnPartner,
          onClick: _ctx.handleOkTurnPartner
        }, {
          default: _withCtx(() => [
            _hoisted_70
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_48, [
          _hoisted_49,
          _createVNode(_component_a_input, {
            value: _ctx.formTurnPartner.description,
            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formTurnPartner.description) = $event)),
            placeholder: "Ex: parceria comercial região sul",
            size: "large",
            class: "tp-field"
          }, null, 8, ["value"]),
          _hoisted_50,
          _withDirectives(_createVNode(_component_a_input, {
            value: _ctx.formTurnPartner.accountCpfCnpj,
            "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formTurnPartner.accountCpfCnpj) = $event)),
            placeholder: _ctx.selectedCustomer && _ctx.selectedCustomer.accountType === 1 ? 'CNPJ' : 'CPF',
            size: "large",
            class: "tp-field"
          }, null, 8, ["value", "placeholder"]), [
            [_directive_maska, _ctx.selectedCustomer && _ctx.selectedCustomer.accountType === 1 ? '##.###.###/####-##' : '###.###.###-##']
          ]),
          _hoisted_51,
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", null, [
              _hoisted_53,
              _createVNode(_component_a_input_number, {
                value: _ctx.formTurnPartner.commission,
                "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formTurnPartner.commission) = $event)),
                min: 0,
                max: 100,
                style: {"width":"100%"},
                size: "large"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", null, [
              _hoisted_54,
              _createVNode(_component_a_input_number, {
                value: _ctx.formTurnPartner.discount,
                "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formTurnPartner.discount) = $event)),
                min: 0,
                max: 100,
                style: {"width":"100%"},
                size: "large"
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _hoisted_56,
            _createVNode(_component_a_button, {
              size: "small",
              onClick: _ctx.addPlan
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_PlusOutlined)
              ]),
              default: _withCtx(() => [
                _hoisted_57
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formTurnPartner.plans, (plan, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: plan.uid,
              class: "tp-plan-card"
            }, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("span", null, "Plano " + _toDisplayString(index + 1), 1),
                (_ctx.formTurnPartner.plans.length > 1)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "text",
                      size: "small",
                      onClick: ($event: any) => (_ctx.removePlan(index))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_DeleteOutlined)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", null, [
                  _hoisted_60,
                  _createVNode(_component_a_input, {
                    value: plan.name,
                    "onUpdate:value": ($event: any) => ((plan.name) = $event),
                    placeholder: "Business"
                  }, null, 8, ["value", "onUpdate:value"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_61,
                  _createVNode(_component_a_input_number, {
                    value: plan.value,
                    "onUpdate:value": ($event: any) => ((plan.value) = $event),
                    min: 0,
                    style: {"width":"100%"}
                  }, null, 8, ["value", "onUpdate:value"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_62,
                  _createVNode(_component_a_input_number, {
                    value: plan.userNumber,
                    "onUpdate:value": ($event: any) => ((plan.userNumber) = $event),
                    min: 0,
                    style: {"width":"100%"}
                  }, null, 8, ["value", "onUpdate:value"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_63,
                  _createVNode(_component_a_input_number, {
                    value: plan.envelopeNumber,
                    "onUpdate:value": ($event: any) => ((plan.envelopeNumber) = $event),
                    min: 0,
                    style: {"width":"100%"}
                  }, null, 8, ["value", "onUpdate:value"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_64,
                  _createVNode(_component_a_input_number, {
                    value: plan.whatsappNumber,
                    "onUpdate:value": ($event: any) => ((plan.whatsappNumber) = $event),
                    min: 0,
                    style: {"width":"100%"}
                  }, null, 8, ["value", "onUpdate:value"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_65,
                  _createVNode(_component_a_input_number, {
                    value: plan.periodTest,
                    "onUpdate:value": ($event: any) => ((plan.periodTest) = $event),
                    min: 0,
                    style: {"width":"100%"}
                  }, null, 8, ["value", "onUpdate:value"])
                ])
              ])
            ]))
          }), 128)),
          _hoisted_66,
          _createVNode(_component_a_radio_group, {
            value: _ctx.formTurnPartner.featureType,
            "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formTurnPartner.featureType) = $event)),
            class: "tp-features"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio, { value: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ApiOutlined),
                  _hoisted_67
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, { value: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_MobileOutlined),
                  _hoisted_68
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onCancel"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.isShowPartnerView,
      "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.isShowPartnerView) = $event)),
      centered: "",
      footer: null,
      maskClosable: false,
      width: "640px",
      wrapClassName: "partner-modal"
    }, {
      title: _withCtx(() => [
        _hoisted_71,
        (_ctx.selectedCustomer)
          ? (_openBlock(), _createElementBlock("p", _hoisted_72, _toDisplayString(_ctx.selectedCustomer.name), 1))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (_ctx.partnerDataView)
          ? (_openBlock(), _createElementBlock("section", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", null, [
                  _hoisted_75,
                  _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.partnerDataView.parameterization?.commission ?? '--') + "%", 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_77,
                  _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.partnerDataView.parameterization?.discount ?? '--') + "%", 1)
                ])
              ]),
              _hoisted_79,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnerDataView.plans, (plan) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: plan.name,
                  class: "tp-plan-view-row"
                }, [
                  _createElementVNode("span", null, _toDisplayString(plan.name), 1),
                  _createElementVNode("span", null, "R$ " + _toDisplayString(plan.value) + " · " + _toDisplayString(plan.userNumber) + " usuários · " + _toDisplayString(plan.envelopeNumber) + " envelopes · " + _toDisplayString(plan.whatsappNumber) + " whatsapp", 1)
                ]))
              }), 128)),
              _hoisted_80,
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.hasFeature(1) ? 'tp-feature-on' : 'tp-feature-off')
                }, [
                  _createVNode(_component_ApiOutlined),
                  _hoisted_82
                ], 2),
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.hasFeature(2) ? 'tp-feature-on' : 'tp-feature-off')
                }, [
                  _createVNode(_component_MobileOutlined),
                  _hoisted_83
                ], 2)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}